import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useMediaQuery } from '@mui/system'
import AdminSidebar from '../../Container/AdminUser/AdminSidebar'
import ServicesList from '../../Components/AdminUser/Services/ServicesList'
import ProviderRouteAccess from './ProviderRouteAccess'
import BusinessesList from '../../Components/AdminUser/Businesses/BusinessesList'
import EmployeesList from '../../Components/AdminUser/Employees/EmployeesList'
import AppointmentsList from '../../Components/AdminUser/Appointments/AppointmentsList'
import CustomersList from '../../Components/AdminUser/Customers/CustomersList'
import ReferalSourcesList from '../../Components/AdminUser/ReferalSources/ReferalSourcesList'
import ReferalSourcesDetails from '../../Components/AdminUser/ReferalSources/ReferalSourcesDetails'
import ReferLeads from '../../Components/AdminUser/ReferLeads/ReferLeads'


const ProviderRoutes = () => {
  const isLargeScreen = useMediaQuery("(min-width:1441px)");

  return (
    <div>
          <div>
      <AdminSidebar />
      <div style={{ marginLeft: isLargeScreen ? '250px' : '0', flexGrow: 1, padding: "10px" }}>

      <Routes>
          <Route path="/services" element={<ProviderRouteAccess element={<ServicesList />} />}/>
          <Route path="/companies" element={<ProviderRouteAccess element={<BusinessesList />} />}/>
          <Route path="/employees" element={<ProviderRouteAccess element={<EmployeesList/>} />}/>
          <Route path="/appointments" element={<ProviderRouteAccess element={<AppointmentsList/>} />}/>
          <Route path="/customers" element={<ProviderRouteAccess element={<CustomersList/>} />}/>
          <Route path="/referal-sources" element={<ProviderRouteAccess element={<ReferalSourcesList/>} />}/>
          <Route path="/referal-source-details/:id/:name" element={<ProviderRouteAccess element={<ReferalSourcesDetails/>} />}/>
          <Route path="/referal-leads" element={<ProviderRouteAccess element={<ReferLeads/>} />}/>
      </Routes>
    </div>
    </div>
    </div>
  )
}

export default ProviderRoutes